import { STEP_DEFINITIONS } from './Config';

export const getSteps = ({
    isFormFilled,
    isAlreadyMember
}: {
    isFormFilled: boolean;
    isAlreadyMember: boolean;
}) => {
    // ✅ Case 1: Form already filled → 4 steps
    if (isFormFilled) {
        return [
            STEP_DEFINITIONS.ALREADY_MEMBER,
            STEP_DEFINITIONS.EMAIL,
            { ...STEP_DEFINITIONS.CONTACT, clickable: true },
            // STEP_DEFINITIONS.CONTACT,
            STEP_DEFINITIONS.BUSINESS
        ];
    }

    // ✅ Case 2: Not filled + already member → 3 steps
    if (!isFormFilled && isAlreadyMember) {
        return [
            { ...STEP_DEFINITIONS.CONTACT, clickable: true },
            STEP_DEFINITIONS.EMAIL,
            STEP_DEFINITIONS.BUSINESS
        ];
    }

    // ✅ Case 3: Not filled + not member → 4 steps
    return [
        STEP_DEFINITIONS.ALREADY_MEMBER,
        STEP_DEFINITIONS.EMAIL,
        // STEP_DEFINITIONS.CONTACT,
        { ...STEP_DEFINITIONS.CONTACT, clickable: true },
        STEP_DEFINITIONS.BUSINESS
    ];
};
export const primaryButtonStyle = {
    backgroundColor: '#003764',
    color: '#ffffff',
    '--bg-cut-background': '#003764'
} as React.CSSProperties;

export const secondaryButtonStyle: React.CSSProperties = {
    '--bg-cut-background': '#ffffff'
} as React.CSSProperties;
export const scrollToSection = () => {
    const element = document.getElementById('expansion-form');

    if (element) {
        const y =
            element.getBoundingClientRect().top + window.pageYOffset - 100;

        window.scrollTo({
            top: y,
            behavior: 'smooth'
        });
    }
};
